
// https://gist.github.com/blixt/f17b47c62508be59987b

export default function randomGenerator(seed:number = 123) {

    seed = seed % 2147483647;

    const fn = (a=0, b=1) => {
        seed = seed * 16807 % 2147483647;
        const n = (seed - 1) / 2147483646;

        if(a>b){
            [a,b] = [b,a]; 
        }

        return (n*(b-a))+a;

    }
                
    return fn;

}